import ApiHandler from '@/api/base'

const createHeaders = token => {
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
}

class WebAppAuthenticationApiHandler extends ApiHandler {
  async preLogout() {
    await this.http.post('/prelogout')
  }

  async postLogin({ token } = {}) {
    await this.http.post('/postlogin', null, {
      ...createHeaders(token)
    })
  }

  async MCPPostLogin({ token } = {}) {
    const { data } = await this.http.post('/mcp/postlogin', null, {
      ...createHeaders(token)
    })

    return data
  }

  async connectMCP({ token, iss } = {}) {
    const { data } = await this.http.post(
      '/mcp/token',
      { iss },
      {
        ...createHeaders(token)
      }
    )

    return data
  }
}

export default WebAppAuthenticationApiHandler
